import clsx from 'clsx'
import React, { useState } from 'react'

import { AnalyticsActionType } from 'types/common/analytics.type'

import styles from './Video.module.scss'
import VideoPlaceholder from '../../../assets/images/heroBanner/hero_banner_video_placeholder.jpeg'
import { EVENTS, trackAnalytics } from '../../../utils/analytics'
import PlayIcon from '../../common/playIcon/PlayIcon'
import VideoModal from '../videoModal/VideoModal'

interface VideoProps {
  src: string
  className?: string
  children?: React.ReactNode
  openModal: boolean
  setOpenModal: (open: boolean) => void
}

const Video = ({ src, className, children, openModal, setOpenModal }: VideoProps) => {
  const [playModalVideo, setPlayModalVideo] = useState(false)

  const handlePlayIconClick = () => {
    setPlayModalVideo(true)
    if (setOpenModal) setOpenModal(true)
    trackAnalytics({
      type: AnalyticsActionType.action,
      payload: EVENTS.INNOVATION_VIEW_VIDEO,
    })
  }

  return (
    <>
      <div
        className={clsx(className, styles.videoContainer)}
        onClick={handlePlayIconClick}
        style={{ backgroundImage: `url(${VideoPlaceholder})` }}
      >
        {children}
        <PlayIcon onClick={handlePlayIconClick} hoverActive={true} className={styles.playIcon} />
      </div>
      <VideoModal
        show={openModal}
        setShow={setOpenModal}
        videoSrc={src}
        setPlayVideo={setPlayModalVideo}
        playVideo={playModalVideo}
      />
    </>
  )
}

export default Video
